import BaseService from './base';

class ResellerService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/reseller`;
  }

  getKits(params) {
    return this.request(`${this.getUrl()}/kits`, params )
      .then(response => response.data)
      .catch(err => console.error(err));
  }
}

export default new ResellerService();
